export default __webpack_public_path__ + "static/media/hnh3.a2afbcfe.png";